export default "__VITE_ASSET__CoQB_A2w__"